<template>
  <span class="customer-service-loader" aria-hidden="true"></span>
</template>

<script>
/* global env */
const SCRIPT_ID = 'online-customer-service-script'
const DEFAULT_JIVOCHAT_WIDGET_ID = 'PnjN73D54c'
const YUNDADESK_SCRIPT_URL = 'https://cdn.yundadesk.com/widget.js'

export default {
  name: 'CustomerService',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loaded: false,
      placementObserver: null
    }
  },
  watch: {
    config: {
      immediate: true,
      handler (config) {
        this.loadWidget(config)
      }
    }
  },
  methods: {
    getSetting (config, name, fallback) {
      if (typeof config[name] !== 'undefined' && config[name] !== null) {
        return config[name]
      }
      if (typeof env !== 'undefined' && typeof env[name.toUpperCase()] !== 'undefined') {
        return env[name.toUpperCase()]
      }
      return fallback
    },
    loadWidget (config) {
      if (!config || this.loaded) {
        return
      }

      const enabled = String(this.getSetting(config, 'customer_service_enabled', '1')) !== '0'
      if (!enabled) {
        return
      }

      const provider = String(this.getSetting(config, 'customer_service_provider', 'jivochat')).toLowerCase()
      const existingScript = document.getElementById(SCRIPT_ID)
      if (existingScript) {
        this.loaded = true
        if (provider !== 'yundadesk') {
          this.startJivoPlacement()
        }
        return
      }

      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.async = true

      if (provider === 'yundadesk') {
        const widgetKey = String(this.getSetting(config, 'yundadesk_widget_key', '')).trim()
        if (!/^[A-Za-z0-9_-]{1,100}$/.test(widgetKey)) {
          return
        }
        script.src = YUNDADESK_SCRIPT_URL
        script.setAttribute('data-yd-key', widgetKey)
      } else {
        const widgetId = String(this.getSetting(config, 'jivochat_widget_id', DEFAULT_JIVOCHAT_WIDGET_ID)).trim()
        if (!/^[A-Za-z0-9_-]{1,100}$/.test(widgetId)) {
          return
        }
        script.src = 'https://code.jivosite.com/widget/' + widgetId
      }

      script.onerror = () => {
        this.loaded = false
        if (script.parentNode) {
          script.parentNode.removeChild(script)
        }
      }
      if (provider !== 'yundadesk') {
        script.onload = () => {
          this.startJivoPlacement()
        }
        this.startJivoPlacement()
      }
      document.body.appendChild(script)
      this.loaded = true
    },
    startJivoPlacement () {
      this.applyJivoPlacement()
      if (this.placementObserver) {
        return
      }
      this.placementObserver = new MutationObserver(() => {
        this.applyJivoPlacement()
      })
      this.placementObserver.observe(document.body, {
        childList: true,
        subtree: true
      })
    },
    applyJivoPlacement () {
      const wrapper = document.querySelector('jdiv.__jivoDesktopButton, jdiv.__jivoMobileButton')
      if (!wrapper) {
        return
      }

      this.setImportantStyle(wrapper, 'width', '48px')
      this.setImportantStyle(wrapper, 'height', '48px')
      this.setImportantStyle(wrapper, 'right', '12px')
      this.setImportantStyle(wrapper, 'bottom', 'calc(66px + env(safe-area-inset-bottom, 0px))')

      const button = wrapper.querySelector('jdiv[class*="button__"]')
      if (button) {
        this.setImportantStyle(button, 'width', '65px')
        this.setImportantStyle(button, 'height', '65px')
        this.setImportantStyle(button, 'margin', '0px')
        this.setImportantStyle(button, 'transform', 'scale(0.7385)')
        this.setImportantStyle(button, 'transform-origin', 'top left')
      }

      const menu = wrapper.querySelector('jdiv[class*="menuWrap__"]')
      if (menu) {
        this.setImportantStyle(menu, 'display', 'none')
      }
    },
    setImportantStyle (element, name, value) {
      if (element.style.getPropertyValue(name) !== value || element.style.getPropertyPriority(name) !== 'important') {
        element.style.setProperty(name, value, 'important')
      }
    }
  },
  beforeDestroy () {
    if (this.placementObserver) {
      this.placementObserver.disconnect()
    }
  }
}
</script>

<style>
.customer-service-loader {
  display: none;
}

jdiv.__jivoDesktopButton,
jdiv.__jivoMobileButton {
  width: 48px !important;
  height: 48px !important;
  right: 12px !important;
  bottom: calc(66px + env(safe-area-inset-bottom, 0px)) !important;
}

jdiv.__jivoDesktopButton > jdiv[class*="button__"],
jdiv.__jivoMobileButton > jdiv[class*="button__"] {
  width: 65px !important;
  height: 65px !important;
  margin: 0 !important;
  transform: scale(0.7385) !important;
  transform-origin: top left !important;
}

jdiv.__jivoDesktopButton > jdiv[class*="menuWrap__"],
jdiv.__jivoMobileButton > jdiv[class*="menuWrap__"] {
  display: none !important;
}

iframe[title="YundaDesk Web Widget"][style*="width: min(104px, 100vw)"] {
  transform: translate(9px, -45px) scale(0.857142857) !important;
  transform-origin: bottom right !important;
}
</style>
